import api, { ApiCallReturn } from '../api';

export const postChallengeReward = (challengeId: number): ApiCallReturn => api.post(`/challenges/${challengeId}/users/reward`);
export const postChallengeEvidence = (challengeId: number, image: string): ApiCallReturn => api.post(`/challenges/${challengeId}/users/evidence`, {image});
